import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
} from "@mui/material";
import { resetState } from "./buildingProfileTableSlice.js";
import { useDispatch, useSelector } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import { useSnackbar } from "notistack";
import RenderProperty from "./RenderProperty.js";
import CustomButton from "../../../../../../components/buttons/CustomButton.js";
import { saveProperties } from "../../../../api/tddBuildingProfileApi.js";
import { resetPromptState } from "../../../slice/dataSlice.js";
import { getIntlTranslation } from "../../../../../../utils/helper.js";
// import { getCapexDetail } from "../../../../api/capexOverviewApi.js";
// import { saveImage } from "../../../../api/imageContainerApi.js";
// import html2canvas from 'html2canvas';
// import SendIcon from '@mui/icons-material/Send';
// import { useCurrentPng } from 'recharts-to-png';
// import imageCompression from 'browser-image-compression';
// import { v4 as uuidv4 } from 'uuid';
// import { getImageFileFromUrl } from "../../../../../../components/imageUploader/imageProcessing.js";

// Import the CostDistributionPieChart component
// import CostDistributionPieChart from "../../../../../../components/CostDistributionPieChart.js";

// const options = {
//   maxSizeMB: 6,
//   useWebWorker: true,
// };

export default function BuildingProfileTable(props) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const chapterState = useSelector((state) => state.tddChapters);
  const scope = useSelector((state) => state.container.scope);
  const state = useSelector((state) => state.buildingProfileTable);
  const openAsset = useSelector((state) => state.openAsset);
  // const capexOverviewObj = useSelector((state) => state.capexOverview);
  const { data, reportType } = props;
  const [itemList, setItemList] = useState([]);

  // const [capexData, setCapexData] = useState([]);
  // const [sendingImage, setSendingImage] = useState(false);

  // const pieChartRef = useRef(null);
  // const imageUploadState = useSelector((state) => state.imageUpload);
  // const [png, { ref: chartRef }] = useCurrentPng();

  // Fetch CAPEX data when component mounts
  // useEffect(() => {
  //   if (scope.projectIdent) {
  //     dispatch(getCapexDetail(scope.projectIdent));
  //   }
  // }, [dispatch, scope.projectIdent]);

  // Process CAPEX data when it's loaded
  // useEffect(() => {
  //   if (capexOverviewObj && capexOverviewObj.type === "SUCCESS") {
  //     setCapexData(capexOverviewObj.data);
  //   }
  // }, [capexOverviewObj]);

  useEffect(() => {
    if (!!data && data.properties.length > 0) {
      const sorted = data.properties.toSorted((a, b) => a.nodeOrder - b.nodeOrder);
      setItemList(sorted);
    }
  }, [data, data.properties, dispatch, openAsset.ident, reportType]);

  useEffect(() => {
    if (state.save.type === "SAVED") {
      state.save.messages.forEach((element) => {
        enqueueSnackbar(element, {
          variant: "success",
          autoHideDuration: 2000,
        });
      });
      props.onSaveSuccess(state.save.data);
      dispatch(resetState());
      dispatch(resetPromptState());
    }
  }, [
    reportType,
    chapterState.currentSelection?.chapterIdent,
    chapterState.currentSelection?.sectionIdent,
    dispatch,
    openAsset.ident,
    scope.projectIdent,
    scope.projectLanguageCode,
    state.save.type,
  ]);

  // Handle image upload response
  // useEffect(() => {
  //   if (imageUploadState && imageUploadState.type === "SUCCESS") {
  //     enqueueSnackbar('Cost distribution sent successfully', {
  //       variant: 'success',
  //       autoHideDuration: 2000,
  //     });
  //     setSendingImage(false);
  //   } else if (imageUploadState && imageUploadState.type === "ERROR") {
  //     enqueueSnackbar('Error sending cost distribution', {
  //       variant: 'error',
  //       autoHideDuration: 2000,
  //     });
  //     setSendingImage(false);
  //   }
  // }, [imageUploadState, enqueueSnackbar]);

  // Send image to backend
  // const handleSendToBackend = async () => {
  //   if (!pieChartRef.current) {
  //     enqueueSnackbar('Chart reference not found', {
  //       variant: 'error',
  //       autoHideDuration: 2000,
  //     });
  //     return;
  //   }

  //   setSendingImage(true);
    
  //   try {
  //     // Use html2canvas to capture the chart
  //     const canvas = await html2canvas(pieChartRef.current, {
  //       backgroundColor: '#ffffff',
  //       logging: false,
  //       scale: 2,
  //       useCORS: true
  //     });

  //     // Convert canvas to blob
  //     const blob = await new Promise((resolve) => {
  //       canvas.toBlob(resolve, 'image/png');
  //     });

  //     // Create a File object from the blob
  //     const file = new File([blob], 'cost-distribution.png', { type: 'image/png' });

  //     // Compress the file
  //     const compressedFile = await imageCompression(file, options);

  //     // Create FormData
  //     const formData = new FormData();
      
  //     // IMPORTANT: The order and field names must match what your backend expects
  //     // If your backend expects individual fields, append them like this:
  //     formData.append('type', 'imageMetaDto');
  //     formData.append('imageIdent', uuidv4());
  //     formData.append('parentIdent', 'a289911c-f9da-4256-ae2e-77f7e8ce72b7');
  //     formData.append('primary', 'false'); // Send as string
  //     formData.append('deleted', 'false'); // Send as string
  //     formData.append('caption', '');
  //     formData.append('fileName', 'cost-distribution.png');
  //     formData.append('order', '3'); // Send as string
  //     formData.append('assetIdent', openAsset.ident);
  //     formData.append('edited', 'false'); // Send as string
  //     formData.append('source', '');
  //     formData.append('multipartFile', compressedFile); // This is the actual file


  //     // Dispatch the save action
  //     dispatch(saveImage({
  //       formData: formData, // Make sure this matches what your API expects
  //       projectIdent: scope.projectIdent,
  //       api: reportType,
  //     }));

  //   } catch (error) {
  //     console.error('Error capturing chart:', error);
  //     enqueueSnackbar('Error preparing image: ' + error.message, {
  //       variant: 'error',
  //       autoHideDuration: 3000,
  //     });
  //     setSendingImage(false);
  //   }
  // };

  // Calculate cost summary data
  // const getCostSummaryData = () => {
  //   if (!capexData || capexData.length === 0) return null;
    
  //   const shortTermTotal = capexData.reduce((sum, item) => sum + (item.shortTermCost || 0), 0);
  //   const mediumTermTotal = capexData.reduce((sum, item) => sum + (item.mediumTermCost || 0), 0);
  //   const longTermTotal = capexData.reduce((sum, item) => sum + (item.longTermCost || 0), 0);
  //   const total = shortTermTotal + mediumTermTotal + longTermTotal;
    
  //   return {
  //     shortTerm: { value: shortTermTotal, percentage: total > 0 ? (shortTermTotal / total * 100).toFixed(1) : 0 },
  //     mediumTerm: { value: mediumTermTotal, percentage: total > 0 ? (mediumTermTotal / total * 100).toFixed(1) : 0 },
  //     longTerm: { value: longTermTotal, percentage: total > 0 ? (longTermTotal / total * 100).toFixed(1) : 0 },
  //     total: total
  //   };
  // };

  const handleSave = () => {
    let temp = [];
    itemList.forEach((item) => {
      let updatedNodes = item.nodeValue.filter((f) => f.updated);
      if (updatedNodes.length > 0) {
        temp.push({ ...item, reportType: reportType, nodeValue: updatedNodes });
      }
    });
    
    dispatch(
      saveProperties({
        projectIdent: scope.projectIdent,
        data: temp,
      })
    );
  };

  const renderTableStructure = () => {
    return (
      <>
        <table className="custom-table custom-scrollBar">
          <tbody>
            {/* Cost Distribution Row - COMMENTED OUT */}
            {/* {capexData && capexData.length > 0 && (
              <tr>
                <td colSpan="2" style={{ padding: '20px' }}>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography 
                      variant="h6" 
                      sx={{ mb: 2, fontWeight: 'bold', textTransform: 'uppercase' }}
                    >
                      COST DISTRIBUTION
                    </Typography>
                    
                    <Paper 
                      ref={pieChartRef}
                      elevation={1} 
                      sx={{ 
                        p: 2, 
                        backgroundColor: '#fafafa',
                        maxWidth: 600,
                        margin: '0 auto'
                      }}
                    >
                      <CostDistributionPieChart data={capexData} ref={chartRef} />
                    </Paper>
                    
                    <Button
                      variant="contained"
                      endIcon={<SendIcon />}
                      onClick={handleSendToBackend}
                      disabled={sendingImage}
                      sx={{
                        mt: 2,
                        backgroundColor: '#254a9a',
                        '&:hover': {
                          backgroundColor: '#1a3670',
                        },
                        '&:disabled': {
                          backgroundColor: '#cccccc',
                        },
                      }}
                    >
                      {sendingImage ? 'Sending...' : 'Send to Backend'}
                    </Button>
                  </Box>
                </td>
              </tr>
            )} */}
            
            {/* Regular property rows */}
            <RenderProperty properties={itemList} onListUpdate={(list) => setItemList(list)}/>
          </tbody>
        </table>
      </>
    );
  };

  return (
    <div className="d-flex flex-column h-100 w-100 justify-content-center p-1">
      {!!itemList && itemList.length > 0 ? (
        <>
          <Box
            className="d-flex flex-column w-100 justify-content-center"
            style={{ height: "calc(100% - 30px)", overflowY: "auto" }}
          >
            <div
              id="building-profile-container"
              className="d-flex flex-column w-100 justify-content-center"
            >
              {/* Render everything through the table structure */}
              <Box className="d-flex h-100 w-100 justify-content-center">
                {renderTableStructure()}
              </Box>
            </div>
          </Box>
          <div
            style={{
              width: "100%",
              overflowY: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 5,
              marginTop: 5,
              position: "sticky",
              bottom: 0,
              zIndex: 1500,
              backgroundColor: "#ffff",
            }}
          >
            <CustomButton
              id={"save_current_version"}
              buttonText="_save"
              variant="button"
              className="g-btn-primary"
              style={{
                margin: 2,
                height: 40,
                width: "100%",
                padding: 5,
              }}
              tooltip={{
                title: getIntlTranslation("tooltip.save"),
              }}
              handleClick={(e) => {
                handleSave();
              }}
            />
          </div>
        </>
      ) : (
        <>
          <Box className="w-100">
            <LinearProgress />
          </Box>
        </>
      )}
    </div>
  );
}